import { Component, inject, input, output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FormGroupAtpHtml } from '../models/HtmlModels';
import { VoucherAtpHandlerService } from '../service/voucher-atp-handler.service';
import { FormArrayContextParameters, FormGroupContextBase, FormGroupSubConfig } from '../models/FormModels';
import { ContextBase } from '../../../models/response/AtpConfig';

@Component({
  selector: 'app-voucher-atp-form',
  templateUrl: './voucher-atp-form.component.html',
  styleUrls: ['./voucher-atp-form.component.scss'],
  standalone: false
})
export class VoucherAtpFormComponent {
  private voucherAtpHandlerService = inject(VoucherAtpHandlerService);

  formGroupAtpHtml = input<FormGroupAtpHtml[]>([]);
  canModify = input.required<boolean>();

  removeContextConfig = output();
  removeContextBase = output<number>();

  addNewSubConfig(formGroupSubConfig: FormGroup<FormGroupSubConfig>) {
    const contextBase: ContextBase = {
      configType: 'DOMAIN'
    };
    const name = `Domain-${formGroupSubConfig.controls.subConfig.length}`;
    const formGroup: FormGroup<FormGroupContextBase> = this.voucherAtpHandlerService.createFormGroupContextBase(
      name,
      contextBase,
      !this.canModify()
    );
    formGroupSubConfig.controls.subConfig.push(formGroup);
    formGroupSubConfig.markAsDirty();
  }

  addParameters(formArray: FormArray<FormGroup<FormArrayContextParameters>>, type: 'secureParameters' | 'parameters') {
    const FormGroup = this.voucherAtpHandlerService.createFormGroupParameters('', '', !this.canModify());
    formArray.push(FormGroup);
    formArray.markAsDirty();
  }
}

